export const scrollLockClass = 'disabled-scroll'

export interface IScrollLockListeners {
  blockScrollGesture: (event: WheelEvent | TouchEvent) => void
  restoreScrollPosition: () => void
  blockScrollKeydown: (event: KeyboardEvent) => void
}

export function attachScrollLock(element: HTMLElement, listeners: IScrollLockListeners) {
  element.addEventListener('wheel', listeners.blockScrollGesture, {passive: false})
  element.addEventListener('touchmove', listeners.blockScrollGesture, {passive: false})
  element.addEventListener('scroll', listeners.restoreScrollPosition)
  element.addEventListener('keydown', listeners.blockScrollKeydown)
}

export function detachScrollLock(element: HTMLElement, listeners: IScrollLockListeners) {
  element.removeEventListener('wheel', listeners.blockScrollGesture)
  element.removeEventListener('touchmove', listeners.blockScrollGesture)
  element.removeEventListener('scroll', listeners.restoreScrollPosition)
  element.removeEventListener('keydown', listeners.blockScrollKeydown)
  element.classList.remove(scrollLockClass)
}
